import { useEffect } from 'react';

import { Callout } from '@/components/core/Callout';
import { DataModelAttributesSelector } from '@/components/shared';
import { useDataModel } from '@/hooks/useDataModel';
import { useTranslation } from '@/hooks/useTranslation';
import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { DataModelAttribute, Item } from '@/types/DataModel';

const ChooseAttribute = ({
    item,
    handleSelectedAttributesChange,
    selectedAttributes,
    category
}: {
    item: Item;
    handleSelectedAttributesChange: (selected: DataModelAttribute[]) => void;
    selectedAttributes: DataModelAttribute[];
    category?:string;
}) => {
    const { dataModel } = useDataModel();
    const { t } = useTranslation();

    const attributes =
        dataModel?.filteredLayoutAttributes('mass_update', item) || [];
    const categoryAttribute = dataModel?.attribute('category__');

    let filteredAttributes: DataModelAttribute[] = attributes
        .filter(
            (attribute) =>
                !dataModel?.potentialPrimaryKeyPart(attribute.name) &&
                !dataModel?.isMetaAttribute(attribute.name),
        )
        .filter(
            (attribute, index, self) =>
                index === self.findIndex((t) => t.name === attribute.name),
        )
        .concat(categoryAttribute ? [categoryAttribute] : []);

    if (category) {
        const attrs = dataModel?.categoryAttributes(category) || [];
        filteredAttributes = filteredAttributes.filter((attribute=> {
            const arr = attrs.filter(attr => attr.name === attribute.name);
            return !(arr.length === 0);
        }));
    }
    //TOFIX remove this when we migrate the browse page
    // Grab $rootScope from the angularjs world
    const $angularJSInjector = getInjector();
    const $rootScope = getRootScope($angularJSInjector);
    $rootScope.prepareAttributes(filteredAttributes);

    useEffect(() => {
        handleSelectedAttributesChange(selectedAttributes);
    }, [handleSelectedAttributesChange, selectedAttributes]);

    const handleSelectedChange = (attributes: DataModelAttribute[]) => {
        handleSelectedAttributesChange(attributes);
    };

    return (
        <div className="tw-h-full">
            <Callout className="tw-my-6" variant="info">
                {t('MASS_UPDATE_EDITOR.ATTRIBUTE_SELECTION.DESCRIPTION')}
            </Callout>
            <span className="tw-font-bold tw-my-6">
                {t('MASS_UPDATE_EDITOR.ATTRIBUTE_SELECTION.TEXT')}
            </span>
            <div className="tw-my-6 tw-h-[68%] tw-pb-2">
                <DataModelAttributesSelector
                    attributes={filteredAttributes}
                    selectedAttributes={selectedAttributes}
                    onSelectedChange={handleSelectedChange}
                />
            </div>
        </div>
    );
};

export default ChooseAttribute;
